<template>
  <v-card class="mx-auto mb-2 card">
    <div class="card__inner" :class="{'selected' : selected}">
      <div class="card__inner__text">
        <h2>{{ card.title }}</h2>
      </div>
    </div>
    <v-card-actions>
      <v-switch color="amber" v-model="card.selected"></v-switch>
    </v-card-actions>
  </v-card>
</template>

<script>
// @ is an alias to /src
export default {
  name: "CardWord",
 data() {
    return {
       selected: false
    }
  },
  props: {
    card: Object,
    exercise: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    if (this.exercise) {
      this.doCheck(this.exercise.selectedTiles)
    }
  },
  watch: {
    exercise(val) {
      this.doCheck(val.selectedTiles)
    },
  },
  methods: {
     doCheck(arr) {
      let filteredList = arr.filter(
        (item) => item.id == this.card.id
      );
      if (filteredList.length >= 1) {
        this.card.selected = true;
        this.selected = true;
      } else {
        this.card.selected = false;
        this.selected = false;
      }
  }
  }
};
</script>
